// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MedicalEligibilitySpecialtyPharmacy {
    static getAttributeTypeMap() {
        return MedicalEligibilitySpecialtyPharmacy.attributeTypeMap;
    }
}
MedicalEligibilitySpecialtyPharmacy.discriminator = undefined;
MedicalEligibilitySpecialtyPharmacy.additionalProperties = false;
MedicalEligibilitySpecialtyPharmacy.attributeTypeMap = [
    {
        "name": "availability",
        "baseName": "availability",
        "type": "string"
    },
    {
        "name": "coInsurance",
        "baseName": "coInsurance",
        "type": "string"
    },
    {
        "name": "copay",
        "baseName": "copay",
        "type": "string"
    },
    {
        "name": "name",
        "baseName": "name",
        "type": "string"
    },
    {
        "name": "phone",
        "baseName": "phone",
        "type": "string"
    },
];
//# sourceMappingURL=medicalEligibilitySpecialtyPharmacy.js.map